// project imports
import dashboard from './dashboard';
import pages from './page';
import utilities from './utilities';
import appMenu from './appMenu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [ appMenu]
};

export default menuItems;
